import { useQuery } from '@tanstack/react-query';
import { userRoles } from '../../index';

interface UseUserRolesProps {
  enabled?: boolean;
}

const useUserRoles = ({ enabled = true }: UseUserRolesProps = {}) => {
  const {
    data: rolesData,
    isLoading: isRolesLoading,
    isSuccess: isRolesSuccess,
    isError: isRolesError,
    error: rolesError,
    refetch: refetchRoles,
  } = useQuery({
    queryKey: ['userRoles'],
    queryFn: userRoles,
    enabled,
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: 0,
  });

  return {
    rolesData,
    isRolesLoading,
    isRolesSuccess,
    isRolesError,
    rolesError,
    refetchRoles,
  };
};

export default useUserRoles;
